import { computed, defineComponent, PropType } from 'vue';

export interface FolderNode {
  [key: string]: unknown;
  children: FolderNode[];
}

export default defineComponent({
  name: 'dl-folder-node-component',
  props: {
    rootNode: { type: Object as PropType<FolderNode>, required: true, default: () => ({ children: [] }) }
  },
  emits: ['check'],
  setup(props, { emit }) {
    const parentNode = computed(() => {
      const sortedNode = { ...props.rootNode, children: [...props.rootNode.children] };
      if (sortedNode) {
        const noChildrenArray = sortedNode?.children
          .filter((x) => x.children.length === 0)
          .sort((a, b) => (a.key as string).localeCompare(b.key as string)) as FolderNode[];
        const folderArray = sortedNode?.children
          .filter((x) => x.children.length > 0)
          .sort((a, b) => (a.key as string).localeCompare(b.key as string)) as FolderNode[];
        sortedNode.children = [...noChildrenArray, ...folderArray];
      }
      return sortedNode;
    });

    function getKey(key: any) {
      return `${key as string}`;
    }

    function onCheck(value: string) {
      emit('check', value);
    }

    return { parentNode, onCheck, getKey };
  }
});
